import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

const MusicDistributionHero = ({ headingbefore, mark, headingafter, detail }) => {
  return (
    <section className="banner-section-container position-relative hero_banner" style={{ minHeight: '80vh' }}>
      {/* Background wrapper for the right side image */}
      <div 
        className="banner-video-wrapper d-none d-lg-block"
        style={{
          backgroundImage: 'url(/Images/hero_headphones.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'right center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.9,
          zIndex: -1
        }}
      >
        <div className="banner-video-overlay" style={{ background: 'linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.4) 30%, rgba(0, 0, 0, 0) 100%)' }}></div>
      </div>

      <Container className="r-container position-relative h-100" style={{ zIndex: 2 }}>
        <Row className="h-100 align-items-center">
          <Col lg={7} md={12} className="text-start">
            <div className="d-flex flex-column gap-3">
              {/* Trust Badge */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                className="trusted-badge-premium"
              >
                <span className="dot-pulse"></span>
                Premium Services
              </motion.div>

              {/* Main Heading */}
              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="main-heading-premium"
              >
                {headingbefore} <br />
                <span className="text-purple-gradient">{mark}</span> <br />
                {headingafter}
              </motion.h1>

              {/* Subheading Description */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="banner-description-premium mt-2"
              >
                {detail}
              </motion.p>

              {/* Action Buttons */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="d-flex flex-sm-row flex-column gap-4 mt-4"
              >
                <a
                  href="https://dashboard.fttunes.com/register.php"
                  className="btn-premium-purple button_button__MFmXH button_color__bLscP"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get in touch <FaArrowRight className="ms-2" />
                </a>
              </motion.div>
            </div>
          </Col>
          
          {/* Mobile visible image */}
          <Col xs={12} className="d-block d-lg-none mt-5 text-center">
            <motion.img 
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              src="/Images/hero_headphones.png" 
              alt="Headphones" 
              className="img-fluid" 
              style={{ maxHeight: '300px' }} 
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MusicDistributionHero;
